/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Hero_TitleInputs */

const en_nfp_hero_title = /** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Sovereignty for Your Mission.`)
};

const es_nfp_hero_title = /** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soberanía Digital para tu Misión.`)
};

const fr_nfp_hero_title = /** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souveraineté numérique pour votre mission.`)
};

const de_nfp_hero_title = /** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Souveränität für deine Mission.`)
};

const id_nfp_hero_title = /** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedaulatan Digital untuk Misi Anda.`)
};

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const ja_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const zh_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const ar_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const it_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const ru_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const pt_nfp_hero_title = en_nfp_hero_title;

/** @type {(inputs: Nfp_Hero_TitleInputs) => LocalizedString} */
const ko_nfp_hero_title = en_nfp_hero_title;

/**
* | output |
* | --- |
* | "Digital Sovereignty for Your Mission." |
*
* @param {Nfp_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_hero_title = /** @type {((inputs?: Nfp_Hero_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Hero_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_hero_title(inputs)
	if (locale === "es") return es_nfp_hero_title(inputs)
	if (locale === "fr") return fr_nfp_hero_title(inputs)
	if (locale === "de") return de_nfp_hero_title(inputs)
	if (locale === "ja") return ja_nfp_hero_title(inputs)
	if (locale === "zh") return zh_nfp_hero_title(inputs)
	if (locale === "ar") return ar_nfp_hero_title(inputs)
	if (locale === "id") return id_nfp_hero_title(inputs)
	if (locale === "it") return it_nfp_hero_title(inputs)
	if (locale === "ru") return ru_nfp_hero_title(inputs)
	if (locale === "pt") return pt_nfp_hero_title(inputs)
	return ko_nfp_hero_title(inputs)
});